import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    searchBarContainer: {
        padding: `0 ${theme.spacing(4)} !important`,
        width: 258,
        margin: `${theme.spacing(2)} 0 ${theme.spacing(3)} 0 !important`,
        "& .MuiInputBase-formControl": {
            paddingRight: "0 !important",
        },
        "& #searchBar": {
            padding: theme.spacing(3),
        },
    },
    searchIcon: {
        color: theme.palette.text.secondary,
    },
}));
